import { render, staticRenderFns } from "./TagsModal.vue?vue&type=template&id=97c89354"
import script from "./TagsModal.vue?vue&type=script&lang=js"
export * from "./TagsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports